const horizontalScroll = {
	el: {
		spaceHolder: document.querySelector('.horizontal-scroll-animated__holder'),
		horizontal: document.querySelector('.horizontal-scroll-animated__horizontal'),
		scrollContainer: document.querySelector('.js-horizontal-scroll'),
		contentContainer: document.querySelector('.horizontal-scroll-animated__content'),
		cardsContainer: document.querySelector('.horizontal-scroll-animated__cards'),
		progressBarContainer: document.querySelectorAll('.js-progress')
	},

	fxCalcDynamicHeight(element) {
		const cardsContainerSpacing = parseInt(window.getComputedStyle(this.el.cardsContainer).marginLeft)

		return element.scrollWidth - window.innerWidth + window.innerHeight + cardsContainerSpacing
	},

	fxCalcPercentage(element) {
		const sticky = document.querySelector('.horizontal-scroll-animated__sticky'),
			initialProgress = element.scrollWidth - (sticky.scrollWidth - sticky.offsetWidth) - sticky.offsetWidth,
			maxProgressValue = element.scrollWidth - sticky.offsetWidth

		return Math.floor(initialProgress / maxProgressValue * 100)
	},

	fxUpdateProgressBar(element) {
		const progressBar = element.querySelector('.horizontal-scroll-animated__progress-bar'),
			progressNumbers = element.querySelectorAll('.horizontal-scroll-animated__progress-number')

		progressBar.value = this.fxCalcPercentage(this.el.horizontal)

		for (let i = 0; i < progressNumbers.length; i++)
			this.fxCalcPercentage(this.el.horizontal) >= (i === 0 ? 1 : i * (100 / 3)) ? progressNumbers[i].classList.add('active') : progressNumbers[i].classList.remove('active')
	},

	fxSetSpacingHolder() {
		this.el.spaceHolder.style.height = `${this.fxCalcDynamicHeight(this.el.horizontal) / 10}rem`
	},

	fxAnimateOnScroll() {
		const sticky = document.querySelector('.horizontal-scroll-animated__sticky')
		this.el.horizontal.style.transform = `translateX(-${sticky.offsetTop / 10}rem)`

		for (const bar of this.el.progressBarContainer)
			this.fxUpdateProgressBar(bar)
	},

	events() {
		window.addEventListener('scroll', () => this.fxAnimateOnScroll())
		window.addEventListener('resize', () => this.fxSetSpacingHolder())
	},

	init() {
		if (this.el.scrollContainer) {
			this.events()
			this.fxSetSpacingHolder()
		}
	}
}

horizontalScroll.init()